// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51c71fd3","455":"ac06d5b0","977":"53bd557a"}[chunkId] + ".chunk.js";
};